import { DELIVER_PRINT_TICKETS_GUEST_FLOW_DATA } from '../DeliverPrintTickets';
const viewPdfScreenRegex = /^\/deliver-view-pdf\/[^\/]+$/;
const checkDeliverViewPdf = () => {
  const location = window.location;
  const pathname = location.pathname;
  const deliverPrintTicketsGuestFlowDataInLocalStorage = localStorage.getItem(
    DELIVER_PRINT_TICKETS_GUEST_FLOW_DATA,
  );

  if (deliverPrintTicketsGuestFlowDataInLocalStorage) {
    sessionStorage.setItem(
      DELIVER_PRINT_TICKETS_GUEST_FLOW_DATA,
      deliverPrintTicketsGuestFlowDataInLocalStorage,
    );
    localStorage.removeItem(DELIVER_PRINT_TICKETS_GUEST_FLOW_DATA);
  }

  const deliverPrintTicketsGuestFlowDataInSessionStorage =
    sessionStorage.getItem(DELIVER_PRINT_TICKETS_GUEST_FLOW_DATA);

  const deliverPrintTicketsGuestFlowData =
    !!deliverPrintTicketsGuestFlowDataInSessionStorage
      ? JSON.parse(deliverPrintTicketsGuestFlowDataInSessionStorage)
      : null;

  const accessDeliverViewPdfFromEmailLink =
    viewPdfScreenRegex.test(pathname) &&
    !!deliverPrintTicketsGuestFlowData?.otp &&
    deliverPrintTicketsGuestFlowData?.guest === '1';

  return {
    accessDeliverViewPdfFromEmailLink,
  };
};

export default checkDeliverViewPdf;
